import ImmunityIcon from './ImmunityIcon';

export default ImmunityIcon;
export { ImmunityIcon };
